/**
 * Map → music-key bindings + per-trainer battle-music overrides.
 *
 * Phase 15a. Centralizes the "what plays where" decisions so wiring stays
 * out of WorldScene's ~1900-line file. Adding a new map = one line here.
 *
 * Outdoor maps share the route theme; interiors get their dedicated tracks
 * (Pokémon Center, Gym). The Player's House and Oak's Lab share the slow
 * Pallet variant — keeps the cold-open quiet.
 */
import type { MusicKey } from '../systems/audio';

/** Map basename (the converter file id, what loadMap takes) → music key. */
export const MAP_MUSIC: Record<string, MusicKey> = {
  PalletTown: 'pallet',
  PalletTown_PlayersHouse_1F: 'pallet',
  PalletTown_PlayersHouse_2F: 'pallet',
  PalletTown_RivalsHouse: 'pallet',
  PalletTown_ProfessorOaksLab: 'pallet',
  Route1: 'route1',
  ViridianCity: 'route1', // Cartridge: Viridian shares the route 1 theme.
  ViridianCity_PokemonCenter_1F: 'poke_center',
  ViridianCity_Mart: 'poke_center', // Cartridge: Marts share MUS_POKE_CENTER.
  Route2: 'route1',
  Route2_ViridianForest_SouthEntrance: 'route1',
  Route2_ViridianForest_NorthEntrance: 'route1',
  Route2_House: 'pewter', // Cartridge: Route 2 interiors use MUS_PEWTER.
  Route2_EastBuilding: 'pewter',
  ViridianForest: 'viridian_forest',
  PewterCity: 'pewter',
  PewterCity_Gym: 'gym',
  PewterCity_PokemonCenter_1F: 'poke_center',
  PewterCity_Mart: 'poke_center',
};

/** Trainer scriptRef → battle music override. Brock gets the gym leader
 *  theme; everyone else falls back to the trainer-battle theme. */
export const TRAINER_BATTLE_MUSIC: Record<string, MusicKey> = {
  PewterCity_Gym_EventScript_Brock: 'gym_leader_battle',
};

/** Trainer scriptRef → victory music override. Brock victory = gym fanfare;
 *  other trainers = trainer victory; wild battles = wild victory. */
export const TRAINER_VICTORY_MUSIC: Record<string, MusicKey> = {
  PewterCity_Gym_EventScript_Brock: 'victory_gym',
};
